"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT_SCRIPT = exports.SEGMENT_SCRIPTS = void 0;
const route_1 = require("../route");
exports.SEGMENT_SCRIPTS = route_1.SEGMENT.sub("/scripts");
exports.SEGMENT_SCRIPT = route_1.SEGMENT.sub("/scripts/:scriptId");
